import type { FontGeneratorFontCreateInput as Input } from 'codegen/types'
import { appendTruthyQueryParam } from '../../../utils/query-params'

export function getNewFontByInputUrl(input?: Input | null) {
  if (!input) {
    return 'font-generator'
  }
  const queryParams = new URLSearchParams()
  appendTruthyQueryParam<Input>(queryParams, 'fontCategory', input, 'category')
  appendTruthyQueryParam<Input>(queryParams, 'prompt', input)
  appendTruthyQueryParam<Input>(queryParams, 'visibility', input)
  return `/font-generator?${queryParams.toString()}`
}
